import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { configureStore } from './commons/store';
import { FullRoutes } from './routes/routes';
import AppConfig from './config/appConfig';

Amplify.configure({
  identityPoolId: AppConfig.cognito.IDENTITY_POOL_ID,
  aws_cognito_region: AppConfig.cognito.REGION,
  aws_user_pools_id: AppConfig.cognito.USER_POOL_ID,
  aws_user_pools_web_client_id: AppConfig.cognito.APP_CLIENT_ID,
  // AppSync
  aws_appsync_graphqlEndpoint: AppConfig.graphql.ENDPOINT,
  aws_appsync_region: AppConfig.cognito.REGION,
  aws_appsync_authenticationType: AppConfig.cognito.AUTHENTICATION_TYPE,
  aws_appsync_apiKey: null, // Not required
  Storage: {
    AWSS3: {
      bucket: AppConfig.s3.BUCKET, // REQUIRED -  Amazon S3 bucket name
      region: 'us-east-1',
    },
  },
});

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={configureStore()}>
        <FullRoutes />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
